import '@fontsource/geologica/300.css'
import '@fontsource/geologica/400.css'
import '@fontsource/geologica/500.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/raleway/700.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'

export const BRANDING_FONT_FAMILIES = ['Geologica', 'Montserrat', 'Raleway', 'Open Sans', 'Roboto', 'Lato'] as const

export type BrandingFontFamily = (typeof BRANDING_FONT_FAMILIES)[number]

export const DEFAULT_BRANDING_FONT_FAMILY: BrandingFontFamily = 'Geologica'

const FONT_CSS_STACKS: Record<BrandingFontFamily, string> = {
  Geologica: '"Geologica", Arial, sans-serif',
  Montserrat: '"Montserrat", Arial, sans-serif',
  Raleway: '"Raleway", Arial, sans-serif',
  'Open Sans': '"Open Sans", Arial, sans-serif',
  Roboto: '"Roboto", Arial, sans-serif',
  Lato: '"Lato", Arial, sans-serif',
}

export const getFontCssStack = (fontFamily: BrandingFontFamily): string => FONT_CSS_STACKS[fontFamily]

export const isBrandingFontFamily = (value: unknown): value is BrandingFontFamily =>
  typeof value === 'string' && (BRANDING_FONT_FAMILIES as readonly string[]).includes(value)

export const resolveStoredFontFamily = (configuration?: { fontFamily?: unknown } | null): BrandingFontFamily => {
  const storedFontFamily = configuration?.fontFamily
  return isBrandingFontFamily(storedFontFamily) ? storedFontFamily : DEFAULT_BRANDING_FONT_FAMILY
}
